import OrgItem from './src/index';

export default OrgItem;
